import type { Dispatch } from 'redux';
import { getSourceQueryParam } from 'owa-querystring';
import {
    getGroupFolderForDeepLink,
    loadUserUnifiedGroups,
    deepLinkGroupUrlClickedAction,
} from '../..';

export interface GroupKey {
    groupDomain: string;
    groupAlias: string;
    tabName?: string;
}

export interface GroupFolderKey {
    groupFolder?: string;
}

export function groupRouteActionHandler(dispatch: Dispatch, param: GroupKey) {
    loadUserUnifiedGroups(dispatch);
    const groupSmtp: string = param.groupAlias + '@' + param.groupDomain;
    dispatch(
        deepLinkGroupUrlClickedAction({
            groupSmtp,
            tabName: param.tabName,
            source: getSourceQueryParam(),
        })
    );
}

export function groupFolderRouteActionHandler(dispatch: Dispatch, param: GroupFolderKey) {
    loadUserUnifiedGroups(dispatch);
    getGroupFolderForDeepLink(dispatch)(param.groupFolder, getSourceQueryParam());
}
